const AnwaarNizami = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="max-w-[70rem] mx-auto sm:px-[10rem] lg:flex md:grid md:justify-center lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] sm:text-[30px] font-bold">
              Anwaar Nizami
            </h1>
            <p>Chief Executive Officer</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/AnwaarNizami.png"
              alt=""
              className="xl:h-[26rem] lg:h-[26rem] md:h-[20rem] sm:h-[20rem] h-[17rem] leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="sm:text-[30px] text-[26px] font-bold">
              Anwaar Nizami
            </h1>
            <p>Chief Executive Officer</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[40rem] mx-[2rem] sm:mx-auto my-[4rem] flex flex-col justify-center text-justify gap-4">
        <p>
          Anwaar Nizami is a seasoned supply chain and logistics leader with
          more than 23 years of diversified experience across contract
          logistics, freight management, warehousing and distribution, 3PL
          operations, cold chain development, and integrated supply chain
          solutions. As Chief Executive Officer of TCS Logistics (Pvt) Limited,
          he brings a strategic vision shaped by extensive international
          exposure, operational leadership, and a deep understanding of regional
          and global trade dynamics.
        </p>
        <p>
          Over the course of his career, Anwaar has successfully led large-scale
          logistics operations, business transformation initiatives, and
          strategic growth programs across Pakistan and international markets.
          Prior to joining TCS Logistics, he served TAQ Logistics Solutions as
          Regional Manager and nearly 12 years in Hellmann Worldwide Logistics
          as Director Contract Logistics. He later held the positions of Chief
          Executive Officer / Managing Director at DSV Solutions & Road Pakistan
          and Director at Tristar Group.
        </p>
        <p>
          Anwaar is recognized for his expertise in operational optimization,
          business growth, and supply chain innovation across sectors including
          telecommunications, healthcare, food, power, and cold chain logistics.
          He has successfully led high-performance teams, improved operational
          efficiency, and developed innovative warehousing and cold chain
          solutions, while contributing to agri-logistics and supply chain
          development initiatives in Pakistan.
        </p>
        <p>
          Beyond his corporate responsibilities, Anwaar actively contributes to
          the advancement of Pakistan’s logistics and supply chain industry
          through various leadership and advisory roles. He serves as Vice
          President of the Supply Chain Association of Pakistan, is a member of
          the Chartered Institute of Logistics and Transport (CILT), and serves
          as Chairperson – Council on Supply Chain and Mobility at the National
          Incubation Center Karachi. He is also a Board Member of GS1 Pakistan
          and actively participates in multiple trade and commerce committees
          under the Federation of Pakistan Chambers of Commerce & Industry
          (FPCCI). Additionally, he is a member of FOAP and the Warehousing and
          Logistics Association, and is also a SABIT USA Graduate in Supply
          Chain Management.
        </p>
        <p>
          With a strong commitment to innovation, regional connectivity, and
          operational excellence, Anwaar Nizami continues to play a leading role
          in shaping the future of logistics and supply chain management in
          Pakistan and beyond
        </p>
      </div>
    </div>
  );
};

export default AnwaarNizami;
